import { render, staticRenderFns } from "./AfterSignUp.vue?vue&type=template&id=4119e87f&scoped=true"
import script from "./AfterSignUp.vue?vue&type=script&lang=js"
export * from "./AfterSignUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4119e87f",
  null
  
)

export default component.exports